import React, { useEffect, useState } from "react";
import { useAuth } from "oidc-react";
import { useNavigate } from "react-router-dom";

const LoadingDashboard = () => {
  const { userData } = useAuth();
  const navigate = useNavigate();
  //   useEffect(() => {

  //     setTimeout(()=>{

  //       signOutRedirect();
  //     },3000)

  //   }, []);
  useEffect(() => {
    if(localStorage.getItem("redirect-to")){
      const redirectTo = localStorage.getItem("redirect-to");
      localStorage.removeItem("redirect-to");
      navigate(redirectTo);
    } else{
      navigate("dashboard/default");
    }
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <h1>Loading</h1>
    </div>
  );
};

export default LoadingDashboard;
